import { defineMessages } from 'react-intl'

export default defineMessages({
  genders: {
      id:'containers.EmbeddedProjectPage.genders',
      defaultMessage: 'Genders'
  },
  languages: {
      id:'containers.EmbeddedProjectPage.languages',
      defaultMessage: 'Languages'
  }
})
